// MFC • Infinite Marquee (GSAP-powered)
// Uses window.gsap already present in theme. All comments in English.

(() => {
  if (typeof window === 'undefined') return;

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMarquee(root) {
    if (!root || !window.gsap) return;

    const track = root.querySelector('.mfc-marquee__track');
    const content = track.querySelector('.mfc-marquee__content');
    if (!track || !content) return;

    // Clone once to create seamless loop
    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);

    const speedPx = parseFloat(root.dataset.speedPx || '80'); // px per second
    const direction = (root.dataset.direction || 'left').toLowerCase();
    const pauseOnHover = root.dataset.pause === 'true';

    // Build/refresh timeline
    const build = () => {
      if (root._mfcTl) {
        root._mfcTl.kill();
        root._mfcTl = null;
      }
      // Reset X before measuring
      gsap.set(track, { x: 0 });

      const width = content.getBoundingClientRect().width;
      const distance = Math.max(1, width); // pixels to shift for one loop
      const duration = Math.max(0.001, distance / Math.max(1, speedPx));
      const toX = direction === 'left' ? -distance : distance;

      // Seamless: at each repeat, snap back to 0 (clone ensures no visual jump)
      const tl = gsap.timeline({ repeat: -1, defaults: { ease: 'none' } });
      tl.to(track, {
        x: toX,
        duration,
        onRepeat: () => gsap.set(track, { x: 0 })
      });

      root._mfcTl = tl;
    };

    // Respect reduced motion
    if (prefersReduced()) {
      gsap.set(track, { x: 0 });
    } else {
      build();
    }

    // Pause on hover (if enabled)
    function onEnter() { if (root._mfcTl) root._mfcTl.pause(); }
    function onLeave() { if (root._mfcTl) root._mfcTl.play(); }
    if (pauseOnHover) {
      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mouseleave', onLeave);
    }

    // ResizeObserver to keep it seamless on responsive changes
    let ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(() => {
        if (prefersReduced()) return;
        build();
      });
      ro.observe(root);
    } else {
      // Fallback to window resize
      const onResize = () => { if (!prefersReduced()) build(); };
      window.addEventListener('resize', onResize);
      root._mfcOnResize = onResize;
    }

    // Store cleanup so Theme Editor can re-init on changes
    root._mfcDestroy = () => {
      if (ro) ro.disconnect();
      if (root._mfcOnResize) window.removeEventListener('resize', root._mfcOnResize);
      if (root._mfcTl) root._mfcTl.kill();
      root._mfcTl = null;
    };
  }

  function initAll(container = document) {
    container.querySelectorAll('.mfc-marquee[data-section-id]').forEach((root) => {
      // Prevent double init
      if (!root._mfcInitialized) {
        initMarquee(root);
        root._mfcInitialized = true;
      }
    });
  }

  // Standard page load
  document.addEventListener('DOMContentLoaded', () => initAll());

  // Shopify Theme Editor events
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.mfc-marquee');
    if (root && root._mfcDestroy) root._mfcDestroy();
  });
})();
